import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import AffiliateHeroParallax from "./parallax/AffiliateHeroParallax";

function AffiliateHero() {
  const [dynamicText, setDynamicText] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  const dynamicPhrases = [];

  useEffect(() => {
    const interval = setInterval(() => {
      setIsVisible(false); // Start fade out
      setTimeout(() => {
        setDynamicText((prev) => (prev + 1) % dynamicPhrases.length);
        setIsVisible(true); // Start fade in
      }, 500); // Wait for fade out before changing text
    }, 3000); // Change every 3 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="classic-landing-hero">
      <div className="classic-landing-hero-content">
        <div className="classic-landing-hero-content-left">
          {/* 1. Dynamic header */}
          <h1 className="hero-header">
            <span className="hero-header-static">
              Build income on top of your network{" "}
            </span>
            <span
              className={`hero-header-dynamic ${
                isVisible ? "visible" : "hidden"
              }`}
            >
              {dynamicPhrases[dynamicText]}
            </span>
          </h1>

          {/* 2. Description */}
          <p className="hero-description">
            Share financial services people actually need — backed by real
            expertise — and earn as your network takes action through Plaintr.
          </p>

          {/* 4. Two CTAs */}
          <div className="hero-cta-container">
            <Link to="/sign-up" className="cta-button primary">
              GET STARTED
            </Link>
            <Link to="/sign-in" className="cta-button secondary">
              SIGN IN
            </Link>
          </div>
        </div>
        <div className="classic-landing-hero-content-right">
          <AffiliateHeroParallax />
        </div>
      </div>
    </section>
  );
}

export default AffiliateHero;
